import React, { useState } from 'react'
import { TbCheckbox } from "react-icons/tb"
import { MdOutlineCheckBoxOutlineBlank } from "react-icons/md"
import { Modal } from './modal'
import { ChecklistOwner } from '@oneethos/shared'

type CheckboxIconProps = {
  isCompleted: boolean
  size?: number
  color?: string
  onModalOpen?: () => void
  checklistOwner: ChecklistOwner
}

export const CheckboxIcon = ({
  isCompleted,
  size = 24,
  color = "var(--accent--primary-1)",
  onModalOpen,
  checklistOwner
}: CheckboxIconProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = () => {
    if (onModalOpen) {
      onModalOpen()
    } else {
      setIsModalOpen(true)
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <div
        onClick={handleClick}
        style={{ cursor: 'pointer', display: 'inline-block' }}
        title="Click to view details"
      >
        {isCompleted ? (
          <TbCheckbox color={color} size={size} />
        ) : (
          <MdOutlineCheckBoxOutlineBlank size={size} />
        )}
      </div>

      {isModalOpen && (
        <Modal
          onClose={closeModal}
          dismissable={true}
          hideCloseButton={false}
          title='Checklist Item Information'
        >
          <div>
            {checklistOwner === 'installer' && (
              <p>
                This item requires your attention when the status is <strong>“Needs Action.” </strong>
                Please review the description for detailed instructions on what needs to be completed.
              </p>
            )}

            {checklistOwner === 'bank' && (
              <p>
                This item is handled by the bank. Please review the description for
                details on their responsibilities. If additional action is required, a banker’s comment
                will be displayed with specific instructions.
              </p>
            )}

            {checklistOwner === 'customer' && (
              <p>
                This item requires action from the customer. Review the description for details.
                If the status shows <strong>“Needs Action,”</strong> please contact the
                customer to ensure completion.
              </p>
            )}
          </div>
        </Modal>
      )}
    </>
  )
}

export default CheckboxIcon
